import React from "react";
import { useNavigate } from "react-router-dom";
import { Pickaxe, HeartPulse, ArrowRight, Lock } from "lucide-react";
import { PageHead } from "../components/kit";
import { useApp } from "../context/AppCtx";

const APPS = [
  { w: "mining", icon: Pickaxe, img: "/img/mining.jpg", title: "Mining Procurement", client: "Ntsimbi Platinum Holdings (fictional)", text: "Supplier registry, RFQs, weighted bid evaluation, approvals, POs, contracts and spend intelligence.", tone: "#7A3B1E" },
  { w: "medical", icon: HeartPulse, img: "/img/medical.jpg", title: "Medical Aid Management", client: "Imbali Health Scheme (fictional)", text: "Membership, contributions, claims processing, provider network, benefits and scheme reporting.", tone: "#0E7490" },
];

export default function AdhocHub() {
  const nav = useNavigate();
  const { can } = useApp();
  return (
    <div>
      <PageHead eyebrow="Adhoc Solutions" title="Specialised solutions. Real sector impact." sub="A launcher for two independent client applications. The hub is not a shared database — each application keeps its own tenant, navigation and data boundary." />
      <div className="grid md:grid-cols-2 gap-5">
        {APPS.map((a) => (
          <button key={a.w} onClick={() => nav(`/${a.w}`)} className="card overflow-hidden text-left group hover:-translate-y-1 hover:shadow-xl transition-[transform,box-shadow] duration-300" data-testid={`adhoc-launch-${a.w}`}>
            <div className="h-56 relative overflow-hidden"><img src={a.img} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" /><div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" /><div className="absolute bottom-4 left-5 text-white"><a.icon size={22} /><div className="font-serif text-3xl mt-1">{a.title}</div></div></div>
            <div className="p-5"><div className="pill border-[#E5E0D5] text-[#57534E] bg-[#FAF9F5] mb-2"><Lock size={11} />Isolated tenant · {a.client}</div><p className="text-[13.5px] text-[#57534E]">{a.text}</p><div className="mt-4 font-semibold text-[13px] flex items-center gap-2" style={{ color: a.tone }}>{can(a.w) ? "Launch application" : "Restricted for your role"}<ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" /></div></div>
          </button>
        ))}
      </div>
    </div>
  );
}
